const initialState = window.__STATE__.newCsrf || {};

export default function reducer(state = initialState, action) {
  return state
}
